import React, { useState, useEffect } from 'react';
import { Paper } from '@mui/material';
import { useMapContext } from './Map/MapContext';
// import { flatGroup } from 'd3';

const SystemTotalsPanel = () => {
    const { systemTotals, systemResults, layersVisible, LIDMode, outFileExists } = useMapContext();

    const [systemDiff, setSystemDiff] = useState({flooding: null, runoff: null, infiltration: null, outflow: null});
    const [percentDiff, setPercentDiff] = useState({flooding: null, runoff: null, infiltration: null, outflow: null});

    const formatValue = (value) => {
        return value != null ? value.toFixed(0) : '-';
    };

    const formatDiff = (value, key) => {
        if (value == null) return '';
        const formattedValue = value.toFixed(2);
        const prefix = value > 0 ? '+' : '';
        return `${prefix}${formattedValue}`;
    };

    const getDiffColor = (value, key) => {
        if (value == null) return 'inherit';
        if (key === 'infiltration') {
            return value > 0 ? 'green' : 'red';
        }
        return value < 0 ? 'green' : 'red';
    };

    const paperStyle = {
        backgroundColor: '#071317',
        width: '110px',
        height: outFileExists ? '70px' : '70px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 5px',
    };

    const textStyle = {
        textAlign: 'center',
        color: '#94cfec',
        fontSize: '0.9em',
    };

    const metrics = [
        { icon: '💧', label: 'Flooding', key: 'flooding' },
        { icon: '🌊', label: 'Runoff', key: 'runoff' },
        { icon: '🌱', label: 'Infiltration', key: 'infiltration' },
        { icon: '🚱', label: 'Overflow', key: 'outflow' },
    ];

    useEffect(() => {
        if (systemResults) {
            for (const key in systemResults) {
                const diff = systemResults[key] - systemTotals[key];
                const percentDiff = ((diff) / systemTotals[key]) * 100;
                setSystemDiff(prev => ({...prev, [key]: diff}));
                setPercentDiff(prev => ({...prev, [key]: percentDiff}));
            }
        }
    }, [systemResults]);

    return (
        <div
        style={{
            position: 'absolute',
            top: 15,
            right: 15,
            width: '500px',
            height: outFileExists ? '90px' : '90px',
            backgroundColor: '#071317',
            opacity: 0.9,
            zIndex: 10,
            borderRadius: '5px',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            padding: '10px',
        }}
        >
            {metrics.map(({ icon, label, key }) => (
                <Paper key={key} elevation={3} style={paperStyle}>
                    <div style={textStyle}>
                        {icon} {label}: <br />
                        <b>{formatValue(systemTotals?.[key])}</b> MG <br />
                        {outFileExists && systemDiff[key] !== null && (
                            <span style={{ color: getDiffColor(systemDiff[key], key) }}>
                                {formatDiff(systemDiff[key], key)} MG
                            </span>
                        )}
                    </div>
                </Paper>
            ))}
        </div>
    );
};

export default SystemTotalsPanel;